module.exports = __webpack_public_path__ + "fonts/95d3c1cc1129c2951d7f9ccef835c76e.txt";